import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function SuccessSend(props: SvgIconProps) {
  return (
    <SvgIcon
      fill="none"
      height="128"
      viewBox="0 0 160 128"
      width="160"
      {...props}
    >
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_41588_204917"
          x1="126.101"
          x2="48.7354"
          y1="115.357"
          y2="19.6077"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F6FD" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_41588_204917"
          x1="71.1489"
          x2="31.0804"
          y1="91.1305"
          y2="91.1305"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_41588_204917"
          x1="18.1092"
          x2="-0.0509325"
          y1="70.4995"
          y2="70.4995"
        >
          <stop stopColor="#BBCBEA" />
          <stop offset="1" stopColor="#EFF4FC" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_41588_204917"
          x1="135.664"
          x2="51.0419"
          y1="61.9305"
          y2="61.9305"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint4_linear_41588_204917"
          x1="114.508"
          x2="72.1974"
          y1="53.2877"
          y2="10.9767"
        >
          <stop stopColor="#EFF4FC" />
          <stop offset="1" stopColor="#BBCBEA" />
        </linearGradient>
      </defs>
      <path
        clipRule="evenodd"
        d="M127.91 0.0352299C115.778 -0.685648 100.541 9.84295 80.2266 14.5183C50.562 21.3455 37.4048 33.1079 25.4133 51.7852C13.4219 70.4625 2.14119 86.2785 4.25732 99.713C6.37346 113.148 14.4853 130.514 41.0075 127.696C67.5297 124.878 56.7375 118.325 100.541 117.669C144.416 117.014 163.108 81.691 159.582 56.6569C159.511 56.6569 153.656 1.67359 127.91 0.0352299Z"
        fill="url(#paint0_linear_41588_204917)"
        fillRule="evenodd"
      />
      <path
        d="M34.2912 105.23H68.0124C69.7761 105.23 71.187 103.819 71.187 102.056V77.0117H31.1166V102.056C31.046 103.819 32.5275 105.23 34.2912 105.23Z"
        fill="url(#paint1_linear_41588_204917)"
      />
      <path
        d="M1.41622 76.8705H16.7248C17.5008 76.8705 18.1357 76.2356 18.1357 75.4595V64.1016H0.00529289V75.4595C-0.0652523 76.2356 0.569666 76.8705 1.41622 76.8705Z"
        fill="url(#paint2_linear_41588_204917)"
      />
      <path
        d="M57.7343 91.7196H128.942C132.64 91.7196 135.666 88.6938 135.666 84.9956V32.1445H51.0775V84.9956C51.0102 88.6938 54.036 91.7196 57.7343 91.7196Z"
        fill="url(#paint3_linear_41588_204917)"
      />
      <path
        d="M93.3717 71.5475L135.666 32.1445H51.0102L93.3717 71.5475Z"
        fill="url(#paint4_linear_41588_204917)"
      />
      <path
        clipRule="evenodd"
        d="M143.003 17.7998C133.674 17.7998 126.106 25.3462 126.072 34.6679V34.7941C126.106 44.1158 133.674 51.6621 143.003 51.6621C152.354 51.6621 159.935 44.0818 159.935 34.731C159.935 25.3801 152.354 17.7998 143.003 17.7998Z"
        fill="#07BE6F"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M139.441 42.4073L134.109 37.1872C133.61 36.6979 133.601 35.8959 134.091 35.3961C134.58 34.896 135.382 34.8878 135.882 35.377L139.408 38.8293L150.108 27.9544C150.598 27.4558 151.4 27.4493 151.899 27.9398C152.397 28.4305 152.404 29.2325 151.913 29.7309L139.441 42.4073Z"
        fill="white"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}

export default SuccessSend
